export default "__VITE_ASSET__DPu7ULpo__"